<template>
  <span>{{showText}}</span>
</template>

<script>
  import {dictionaryContainer} from '@/util/common/dictionary'

  export default {
    name: "DictionaryText",
    props: {
      dictionary: {},
      factoryName: {},
      params: {},
      value: {},
      defaultText: {},
      separator: {
        default() {
          return ', ';
        }
      },
    },
    data() {
      return {
        innerDictionary: null
      };
    },
    computed: {
      showText() {
        let text;
        if (this.value == null) {
          text = '';
        } else if (this.value instanceof Array) {
          if (this.innerDictionary == null && this.defaultText == null) {
            text = '';
            for (let i = 0, len = this.value.length; i < len; i++) {
              text += this.value[i];
              if (i < len - 1) {
                text += this.separator;
              }
            }
          } else if (this.innerDictionary == null && this.defaultText != null) {
            text = this.defaultText;
          } else {
            text = '';
            for (let i = 0, len = this.value.length; i < len; i++) {
              text += this.innerDictionary.getText(this.value[i], this.defaultText);
              if (i < len - 1) {
                text += this.separator;
              }
            }
          }
        } else {
          text = this.innerDictionary == null ? this.defaultText == null ? this.value : this.defaultText :
              this.innerDictionary.getText(this.value, this.defaultText);
        }
        return text;
      }
    },
    watch: {
      dictionary: {
        immediate: true,
        deep: true,
        handler() {
          if (this.dictionary != null) {
            this.innerDictionary = this.dictionary;
          }
        }
      }
    },
    mounted() {
      if (this.dictionary != null) {
        this.innerDictionary = this.dictionary;
      } else {
        dictionaryContainer.getDictionary(this.factoryName, this.params).then((result) => {
          this.innerDictionary = result;
        });
      }
    }
  }
</script>

<style scoped>

</style>